<template>
  <img class="http-img" :src="internalSrc" @click="onClick">
</template>

<script>
import mediaMixin from 'src/mixins/mediaMixin'

export default {
  name: 'http-img',
  props: {
    src: {
      type: String,
      default: '',
    },
    isBlobUrl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalSrc: '',
    }
  },
  watch: {
    async src() {
      await this.setImageUrl()
    }
  },
  async mounted() {
    await this.setImageUrl()
  },
  beforeDestroy() {
    if (!this.isBlobUrl) {
      URL.revokeObjectURL(this.internalSrc)
    }
  },
  mixins: [mediaMixin],
  methods: {
    async setImageUrl() {
      if (!this.src) { return }
      let url = this.src
      if (!this.isBlobUrl) {
        url = await this.getBlobUrl(this.src)
      }
      this.internalSrc = url
    },
    onClick(e) {
      this.$emit('click', e)
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
